module.exports = __webpack_public_path__ + "7e2bae7e58ef87a8f6e35d1dc0ccf38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/BRaVE-white.png
// module id = 1349
// module chunks = 17